import Svg, { Defs, Path, RadialGradient, Stop } from "react-native-svg"

const SvgComponent = (props) => (
  <Svg
    width={54}
    height={55}
    viewBox="0 0 54 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M19.1949 20.1972C25.8247 5.7483 37.8889 -2.89622 46.1406 0.889811C54.3924 4.67608 55.7071 19.4589 49.0772 33.9079C42.4474 48.3568 30.3841 57.0003 22.1324 53.2142C19.6723 52.0855 17.8288 49.9795 16.6285 47.1963C16.217 46.242 14.8199 45.9961 14.0324 46.6743C12.8706 47.6747 11.5623 48.2559 10.1636 48.3061C4.89606 48.4952 0.354201 41.0928 0.0196521 31.7733C-0.314775 22.4542 3.6842 14.7461 8.95148 14.5566C11.8818 14.4514 14.5861 16.6959 16.4673 20.3125C17.0005 21.3378 18.6636 21.3622 19.143 20.3107C19.1603 20.2728 19.1776 20.235 19.1949 20.1972Z"
      fill="#FFFDF7"
    />
    <Path
      d="M19.1949 20.1972C25.8247 5.7483 37.8889 -2.89622 46.1406 0.889811C54.3924 4.67608 55.7071 19.4589 49.0772 33.9079C42.4474 48.3568 30.3841 57.0003 22.1324 53.2142C19.6723 52.0855 17.8288 49.9795 16.6285 47.1963C16.217 46.242 14.8199 45.9961 14.0324 46.6743C12.8706 47.6747 11.5623 48.2559 10.1636 48.3061C4.89606 48.4952 0.354201 41.0928 0.0196521 31.7733C-0.314775 22.4542 3.6842 14.7461 8.95148 14.5566C11.8818 14.4514 14.5861 16.6959 16.4673 20.3125C17.0005 21.3378 18.6636 21.3622 19.143 20.3107C19.1603 20.2728 19.1776 20.235 19.1949 20.1972Z"
      fill="#011336"
    />
    <Path
      d="M19.1949 20.1972C25.8247 5.7483 37.8889 -2.89622 46.1406 0.889811C54.3924 4.67608 55.7071 19.4589 49.0772 33.9079C42.4474 48.3568 30.3841 57.0003 22.1324 53.2142C19.6723 52.0855 17.8288 49.9795 16.6285 47.1963C16.217 46.242 14.8199 45.9961 14.0324 46.6743C12.8706 47.6747 11.5623 48.2559 10.1636 48.3061C4.89606 48.4952 0.354201 41.0928 0.0196521 31.7733C-0.314775 22.4542 3.6842 14.7461 8.95148 14.5566C11.8818 14.4514 14.5861 16.6959 16.4673 20.3125C17.0005 21.3378 18.6636 21.3622 19.143 20.3107C19.1603 20.2728 19.1776 20.235 19.1949 20.1972Z"
      fill="url(#paint0_radial_5203_15361)"
    />
    <Defs>
      <RadialGradient
        id="paint0_radial_5203_15361"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(39.1746 -50.2235 43.5775 23.4885 11.7504 49.0602)"
      >
        <Stop offset="0.0336538" stopColor="#FFFDF7" />
        <Stop offset="0.225962" stopColor="#FADAB3" />
        <Stop offset="0.735577" stopColor="#557CFF" />
        <Stop offset="0.993658" stopColor="#011336" />
      </RadialGradient>
    </Defs>
  </Svg>
)

export default SvgComponent;